<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">{{ partner ? 'Editar parceiro' : 'Novo parceiro' }}</div>
        <div @click="close(false)" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent="save" class="form">
        <label>Nome do parceiro</label>
        <input
          v-model="name"
          type="text"
          placeholder="Nome (deve bater com a fonte do cliente)"
          :class="{ error : error.includes('name') }"
        />
        <div v-if="error.includes('name')" class="hint">Informe o nome do parceiro</div>

        <label>Tipo de comissão</label>
        <Selector v-model="commissionType" :options="typeOptions" class="selector_change" @change="onTypeChange" />
        <div v-if="error.includes('commissionType')" class="hint">Selecione o tipo</div>

        <label>{{ commissionType === 'fixed' ? 'Valor fixo (R$ por venda)' : 'Comissão (%)' }}</label>
        <input
          v-if="commissionType === 'percent'"
          :key="'percent'"
          v-model.number="percent"
          type="number"
          min="0"
          max="100"
          step="0.01"
          placeholder="Ex: 10"
          :class="{ error : error.includes('percent') }"
        />
        <money
          v-else
          :key="'fixed'"
          v-bind="formatMoney"
          v-model="percent"
          :class="{ error : error.includes('percent') }"
        ></money>
        <div v-if="error.includes('percent')" class="hint">
          {{ commissionType === 'fixed' ? 'Informe o valor fixo' : 'Informe a porcentagem (0 a 100)' }}
        </div>

        <label class="switch" style="margin-top: 10px;">
          <input v-model="active" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Ativo</span>
        </label>

        <div v-if="errorMsg" class="hint">{{ errorMsg }}</div>
        <button type="submit" class="button-save" style="margin-top: 30px">
          <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Salvar</span>
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { createPartner, updatePartner } from '../api/commission'
import Selector from './Selector'

export default {
  name: 'Partner',
  components: { Selector },
  props: {
    partner: { default: null },
    close: { type: Function, required: true }
  },
  data () {
    return {
      loading: false,
      error: [],
      errorMsg: null,
      name: '',
      commissionType: 'percent',
      percent: null,
      active: true,
      typeOptions: [
        { value: 'percent', text: 'PORCENTAGEM' },
        { value: 'fixed', text: 'VALOR FIXO' }
      ],
      formatMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  mounted () {
    if (this.partner) {
      this.name = this.partner.name || ''
      this.commissionType = this.partner.commissionType || this.partner.commission_type || 'percent'
      this.percent = Number(this.partner.percent)
      this.active = this.partner.active !== false
    }
  },
  methods: {
    onTypeChange () {
      // força re-render do campo valor ao trocar o tipo
      this.percent = this.percent == null || this.percent === '' ? null : Number(this.percent)
    },
    async save () {
      this.error = []
      this.errorMsg = null
      if (!this.name || String(this.name).trim().length < 2) this.error.push('name')
      if (!['percent', 'fixed'].includes(this.commissionType)) this.error.push('commissionType')

      const value = Number(this.percent)
      if (this.percent === null || this.percent === '' || Number.isNaN(value) || value < 0) {
        this.error.push('percent')
      } else if (this.commissionType === 'percent' && value > 100) {
        this.error.push('percent')
      }
      if (this.error.length) return

      this.loading = true
      try {
        const type = this.commissionType
        if (this.partner && this.partner.id) {
          await updatePartner(this.partner.id, this.name, value, this.active, type)
        } else {
          await createPartner(this.name, value, this.active, type)
        }
        this.close(true)
      } catch (err) {
        logger.error(err, this)
        const data = err && err.response && err.response.data
        if (data && data.fields) this.error = data.fields
        this.errorMsg = (data && data.error) || 'Erro ao salvar. Tente novamente.'
      }
      this.loading = false
    }
  }
}
</script>
